import React, { Component } from "react";
import { Table, Accordion, List } from "semantic-ui-react";
import _ from "lodash";
import pickDeep from "../../utils/nodeUtil";
import caution from "../../assets/images/caution.png";
import { getNodeValue } from "../common/Utils";

class Phone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const phoneNodes = [];
    if (this.props.node !== undefined) {
      const addressList = _.get(this.props.node, "addresses[0].address");
      if (addressList !== undefined) {
        let latestAddress;
        let previousDateToRaw = 0;
        _.forEach(addressList, (address) => {
          const phones = _.get(address, "phones");
          if (phones && _.get(phones[0], "phoneInfo")) {
            let dateToRaw = getNodeValue(address, "dateToRaw");
            if (dateToRaw && dateToRaw !== "") {
              if (dateToRaw.length === 5) {
                dateToRaw = `${dateToRaw.substring(
                  0,
                  dateToRaw.length - 1
                )}0${dateToRaw.substring(dateToRaw.length - 1)}`;
              }
              const iDateToRaw = parseInt(dateToRaw, 10);
              if (iDateToRaw > previousDateToRaw) {
                previousDateToRaw = iDateToRaw;
                latestAddress = address;
              }
            }
          }
        });
        let phoneInfos = [];
        pickDeep(latestAddress, "phoneInfo", phoneInfos);
        if (phoneInfos !== undefined) {
          phoneInfos = _.flatten(phoneInfos);
          _.forEach(phoneInfos, (phoneInfo, index) => {
            const phone = _.get(phoneInfo, "phone[0]._", "");
            if (phone !== "") {
              const enhancedPhoneGroupNodes = [];
              pickDeep(phoneInfo, "enhancedPhoneInfo", enhancedPhoneGroupNodes);
              if (enhancedPhoneGroupNodes.length > 0) {
                const phoneInfos1 = _.get(latestAddress, "phones[1].phoneInfo");
                _.forEach(
                  _.flatten(enhancedPhoneGroupNodes),
                  (enhancedPhoneGroupNode, enhIndex) => {
                    const phoneInfo1 = _.filter(
                      phoneInfos1,
                      (a) =>
                        _.get(a, "phone[0]._") ===
                        _.get(enhancedPhoneGroupNode, "phone10[0]._", "")
                    );
                    const indicatorNodes = [];
                    const risks = [];
                    pickDeep(
                      enhancedPhoneGroupNode,
                      "highRiskIndicator",
                      indicatorNodes
                    );
                    if (phoneInfo1 !== undefined && phoneInfo1.length > 0) {
                      phoneNodes.push(
                        <Table.Row
                          key={`phone_row_${index}_${enhIndex}`}
                          className={
                            index % 2 === 1 ? "table-row-odd-child" : ""
                          }
                        >
                          <Table.Cell width={4} className="text-bold">
                            Phone
                          </Table.Cell>
                          <Table.Cell width={5}>
                            {_.get(phoneInfo1[0], "phone[0]._", "")}
                          </Table.Cell>
                          <Table.Cell width={3} className="text-bold">
                            Type
                          </Table.Cell>
                          <Table.Cell width={4}>
                            {_.get(phoneInfo1[0], "providerType[0]._", "")}
                          </Table.Cell>
                        </Table.Row>
                      );
                    } else {
                      phoneNodes.push(
                        <Table.Row
                          key={`phone_row_${index}_${enhIndex}`}
                          className={
                            index % 2 === 1 ? "table-row-odd-child" : ""
                          }
                        >
                          <Table.Cell colSpan={4}>
                            Phone:{" "}
                            {_.get(enhancedPhoneGroupNode, "phone10[0]._", "")}
                          </Table.Cell>
                        </Table.Row>
                      );
                    }
                    const listedName = _.get(
                      enhancedPhoneGroupNode,
                      "listedName[0]._",
                      ""
                    );
                    if (listedName !== "") {
                      phoneNodes.push(
                        <Table.Row
                          key={`phone_listedname_row_${index}_${enhIndex}`}
                          className={
                            index % 2 === 1 ? "table-row-odd-child" : ""
                          }
                        >
                          <Table.Cell
                            width={9}
                            colSpan={2}
                            className="text-bold"
                          >
                            Listed Name:
                          </Table.Cell>
                          <Table.Cell width={7} colSpan={2}>
                            {listedName}
                          </Table.Cell>
                        </Table.Row>
                      );
                    }
                    if (phoneInfo1 !== undefined) {
                      const carrier = _.get(
                        phoneInfo1[0],
                        "phoneCarrier[0]._",
                        ""
                      );
                      if (carrier !== "")
                        phoneNodes.push(
                          <Table.Row
                            key={`phone_carrier_row_${index}_${enhIndex}`}
                            className={
                              index % 2 === 1 ? "table-row-odd-child" : ""
                            }
                          >
                            <Table.Cell colSpan={4}>
                              <span className="text-bold">Carrier: </span>
                              {}
                            </Table.Cell>
                          </Table.Row>
                        );
                    }
                    const riskNodes = [];
                    _.forEach(
                      _.flatten(indicatorNodes),
                      (indicatorNode, subIndex) => {
                        risks.push(
                          _.get(indicatorNode, "description[0]._", "")
                        );
                        riskNodes.push(
                          <List.Item
                            key={`risk_det_${index}__${enhIndex}_${subIndex}`}
                          >
                            <img alt="caution" src={caution} />
                            {_.get(indicatorNode, "description[0]._", "")}
                          </List.Item>
                        );
                      }
                    );
                    phoneNodes.push(
                      <Table.Row
                        key={`phone_Risk_row_${index}_${enhIndex}`}
                        className={index % 2 === 1 ? "table-row-odd-child" : ""}
                      >
                        <Table.Cell colSpan={4}>
                          <span className="text-bold">
                            {" "}
                            High Risk Indicators:{" "}
                          </span>
                          <List>{riskNodes}</List>
                        </Table.Cell>
                      </Table.Row>
                    );
                  }
                );
              } else {
                const providerType = _.get(phoneInfo, "providerType[0]._", "");
                phoneNodes.push(
                  <Table.Row
                    key={`phone_row_${index}`}
                    className={index % 2 === 1 ? "table-row-odd-child" : ""}
                  >
                    <Table.Cell>
                      <span className="text-bold">Phone</span>
                    </Table.Cell>
                    <Table.Cell>
                      {_.get(phoneInfo, "phone[0]._", "")}
                    </Table.Cell>
                    <Table.Cell>
                      {providerType !== "" && (
                        <span className="text-bold">Type</span>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {providerType !== "" && providerType}
                    </Table.Cell>
                  </Table.Row>
                );
                phoneNodes.push(
                  <Table.Row
                    key={`phone_carrier_row_${index}`}
                    className={index % 2 === 1 ? "table-row-odd-child" : ""}
                  >
                    <Table.Cell>
                      <span className="text-bold">Carrier</span>
                    </Table.Cell>
                    <Table.Cell colSpan={12}>
                      {_.get(phoneInfo, "phoneCarrier[0]._", "")}
                    </Table.Cell>
                  </Table.Row>
                );
              }
            }
          });
        }
      }
    }
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`PhoneTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Current Phone
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`PhoneBody`}
          active={this.state.activeIndex === 0}
        >
          <Table className="table-no-border">
            <Table.Body>{phoneNodes}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default Phone;



// WEBPACK FOOTER //
// ./src/components/reports/Phone.js